export type VaultThemePreference = 'light' | 'dark' | 'auto';

/** Resuelve tema auto según preferencia del sistema. */
export function resolveVaultTheme(theme: VaultThemePreference): 'light' | 'dark' {
  if (theme === 'dark') return 'dark';
  if (theme === 'light') return 'light';
  if (typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return 'dark';
  }
  return 'light';
}

export function applyVaultThemeToDocument(isDark: boolean): void {
  if (typeof document === 'undefined') return;
  const html = document.documentElement;
  if (isDark) {
    html.classList.add('dark-theme');
  } else {
    html.classList.remove('dark-theme');
  }
}

export function syncDarkModeStorage(theme: VaultThemePreference): void {
  if (typeof localStorage === 'undefined') return;
  const isDark = resolveVaultTheme(theme) === 'dark';
  localStorage.setItem('dark_mode', String(isDark));
}

/** Aplica tema desde preferencias legacy (`user_preferences.theme`). */
export function applyVaultThemePreference(theme: VaultThemePreference): void {
  const resolved = resolveVaultTheme(theme);
  applyVaultThemeToDocument(resolved === 'dark');
  syncDarkModeStorage(theme);
}

/** Lee `user_preferences` y aplica tema al cargar la app. */
export function initVaultThemeFromStoredPreferences(): VaultThemePreference {
  let theme: VaultThemePreference = 'light';
  if (typeof localStorage !== 'undefined') {
    const raw = localStorage.getItem('user_preferences');
    if (raw) {
      try {
        const prefs = JSON.parse(raw) as { theme?: VaultThemePreference };
        if (prefs.theme === 'light' || prefs.theme === 'dark' || prefs.theme === 'auto') {
          theme = prefs.theme;
        }
      } catch {
        /* ignore */
      }
    } else {
      const dark = localStorage.getItem('dark_mode') === 'true';
      theme = dark ? 'dark' : 'light';
    }
  }
  applyVaultThemePreference(theme);
  return theme;
}
